import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { unwrapResult } from '@reduxjs/toolkit';

import { CustomAlert, CustomButton, Text } from '../../../../../shared/uiComponents';
import { errorNormalizer } from '../../../../../shared/Helpers/functions';
import { Unarchive } from '../../../../../shared/Assets/svgIcons';
import { ButtonWrapper } from '../../../../../components/StyledComponents';

import { DispatchProperties, useSelector } from '../../../../../redux/store';
import { ProgramProperties } from '../../../../../redux/API/ClientAPIHelpers/clientProgramProperties';
import { unarchiveProgram } from '../../../../../redux/State/clientSlice/clientProgramSlice';
import { useProgramsContext } from '../ProgramsContext';

const UnarchiveContent = ({ data, onClose }: { data: ProgramProperties; onClose: () => void }) => {
	const dispatch = useDispatch<DispatchProperties>();
	const { fetchData } = useProgramsContext();

	const unarchiveHandler = () => {
		dispatch(unarchiveProgram(data))
			.then(unwrapResult)
			.then(() => {
				fetchData();
				onClose();
			})
			.catch(errorNormalizer);
	};

	return (
		<ButtonWrapper isInModal>
			<CustomButton title="Yes" onClick={unarchiveHandler} />
			<CustomButton title="Cancel" buttonType="secondaryGray" onClick={onClose} />
		</ButtonWrapper>
	);
};

const UnarchiveComponent = ({ data, onlyIcon }: { data: ProgramProperties; onlyIcon?: boolean }) => {
	const [open, setOpen] = useState<boolean>(false);
	const closeHandler = () => setOpen(false);
	const isUnarchiving = useSelector((state) => state.clientProgram.isArchiving);

	return (
		<>
			<div className="actionRow" onClick={() => setOpen(true)}>
				<div className="actionIcon">
					<Unarchive />
				</div>
				{!onlyIcon && (
					<div className="actionContent">
						<Text title="Unarchive" type="psm" fontWeight="medium" />
					</div>
				)}
			</div>
			<CustomAlert
				isBusy={isUnarchiving}
				title="Do you want to unarchive selected program?"
				open={open}
				onClose={closeHandler}
				Content={({ onClose }) => <UnarchiveContent data={data} onClose={onClose} />}
			/>
		</>
	);
};

export default UnarchiveComponent;
